import { render } from "./DropDownListBibMotivoDispensaMulta.vue?vue&type=template&id=85c8c680&ts=true"
import script from "./DropDownListBibMotivoDispensaMulta.vue?vue&type=script&lang=ts"
export * from "./DropDownListBibMotivoDispensaMulta.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__